import type { LeanCustomsDeclaration } from "../services/leancustomsService";
import { LEANCUSTOMS_EFREIGHT_ORG_ID } from "../constants/leancustoms";

/**
 * Tenant isolation for Lean Customs declarations.
 * Keep in sync with declarationAccessibleToCompany in
 * supabase/functions/leancustoms-declarations/index.ts
 */
export function declarationAccessibleToCompanyOrg(
  declaration: Record<string, unknown>,
  companyLeanCustomsOrgId: string
): boolean {
  const companyOrgId = companyLeanCustomsOrgId.trim();
  if (!companyOrgId) return false;

  const orgId =
    typeof declaration.organization_id === "string"
      ? declaration.organization_id.trim()
      : undefined;
  const declarantId =
    typeof declaration.declarant_id === "string"
      ? declaration.declarant_id.trim()
      : undefined;
  const importerId =
    typeof declaration.importer_id === "string"
      ? declaration.importer_id.trim()
      : undefined;
  const forwarderId =
    typeof declaration.forwarder_id === "string"
      ? declaration.forwarder_id.trim()
      : undefined;

  if (orgId === companyOrgId) return true;
  if (declarantId === companyOrgId) return true;
  if (importerId === companyOrgId) return true;

  if (forwarderId === LEANCUSTOMS_EFREIGHT_ORG_ID) {
    if (declarantId === companyOrgId || importerId === companyOrgId) {
      return true;
    }
  }

  return false;
}

export function filterDeclarationsForCompanyOrg<T extends LeanCustomsDeclaration>(
  declarations: T[],
  companyLeanCustomsOrgId: string | null | undefined
): T[] {
  const orgId = companyLeanCustomsOrgId?.trim();
  if (!orgId) return [];
  return declarations.filter((d) =>
    declarationAccessibleToCompanyOrg(d as Record<string, unknown>, orgId)
  );
}
